import { CommonModule } from '@angular/common';
import { Component, ContentChild, EventEmitter, Output, Input, TemplateRef, type OnInit } from '@angular/core';


export type BesharpSidebarItem = {
  category?: boolean;
  divider?: boolean;
  spacer?: boolean;
  icon?: string;
  command?: () => void;
  link?: string;
  label?: string;
};

export type BesharpSidebarConfig = {
  header?: string;
  subHeader?: string;
  foldable?: boolean;
  class?: string;
  items: BesharpSidebarItem[];
};

@Component({
  selector: 'app-besharp-sidebar',
  imports: [CommonModule],
  templateUrl: './besharp-sidebar.component.html',
  styleUrl: './besharp-sidebar.component.scss',
})
export class BesharpSidebarComponent implements OnInit {

  @Input()
  sidebarConfiguration!: BesharpSidebarConfig;

  @ContentChild('sidebarFooterTemplate') sidebarFooterTemplate?: TemplateRef<any>;

  @Output() collapsedChange = new EventEmitter<boolean>();

  collapsed = false;

  constructor() {}

  ngOnInit(): void {
    if(!this.sidebarConfiguration) {
      throw "You need to add a sidebar configuration to use this component!";
    }
  }

  toggleSidebar() {
    this.collapsed = !this.collapsed;
    this.collapsedChange.emit(this.collapsed);
  }
}
